import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { InternalLink, Icon } from 'ctm-components';

import styles from './edit_my_details.css';

class EditMyDetailsSection extends PureComponent {

    /**
     * Returns an identifier (for keys, data-id)
     *
     * E.g. given prefix = 'Test', str = 'Something Something Something Darkside',
     *  returns "Test.SomethingSomethingSomethingDarkside"
     *
     * @param {string} prefix - prefix to append
     * @param {string} str - string to be camelCased
     * @returns {string} - Identifier
     */
    getIdentifier = (prefix, str) => {
        return `${prefix}.${str.replace(/\W+(.)/g, (m, c) => {
            return c.toUpperCase();
        })}`;
    };

    /**
     * Get the list items to be displayed
     * @returns {Array} - array of <li> for each item given
     */
    getElements = () => {
        const { items } = this.props;
        if (!items) return null;
        return items.map((item) => {
            if (item) return <li key={this.getIdentifier('EditMyDetailsItem', item)} className={styles.item}>{item}</li>;
            return null;
        });
    };

    /**
     * Render the EditMyDetailsSection
     * @returns {*} EditMyDetailsSection
     */
    render = () => {
        const { label, href, onClick, items } = this.props;
        const privateDataHide =  ['Younger Driver', 'Regular Driver', 'Contact Details'].indexOf(label) > -1;
        return (
            <div className={styles.container}>
                <div className={styles.container}>
                    <InternalLink
                        variant="title_link"
                        data-id={this.getIdentifier('EditMyDetailsSection', label)}
                        href={href}
                        onClick={onClick}>
                        <Icon className={styles.icon} variant="ctm_pencil" />
                        {label}
                    </InternalLink>
                </div>
                {items && items.length && <div className={`${styles.items_container}${privateDataHide ? ' data-hj-suppress' : ''}`}>{this.getElements()}</div>}
            </div>
        );
    };

}

EditMyDetailsSection.propTypes = {
    label: PropTypes.string.isRequired,
    href: PropTypes.string,
    items: PropTypes.array,
    onClick: PropTypes.func
};

export { EditMyDetailsSection };
